import { defineStore } from "pinia";

export const useProductionStore = defineStore("production", {
  state: () => ({
    initRegularItems: [],
    regularItems: [],
    regularItemsSellers: [],
    regularItemsInventories: [],
    initPriorityItems: [],
    priorityItems: [],
    priorityItemsSellers: [],
    priorityItemsInventories: [],
    ordersDue: [],
    printers: [],
    loading: false,
    currentInventories: [],
    currentSellers: [],
    lastTab: 1,
    burnEstimate: {},
  }),
});
